"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initUsStateLogic = void 0;
const enableSubmitButton = () => {
  const submitButton = document.getElementById('continue');
  if (submitButton) {
    submitButton.disabled = false;
  }
};
const disableSubmitButton = () => {
  const submitButton = document.getElementById('continue');
  if (submitButton) {
    submitButton.disabled = true;
  }
};
const hideUSStateField = () => {
  const inputUSStateLi = document.querySelector('.inputUSState_li');
  if (inputUSStateLi) {
    inputUSStateLi.style.display = 'none';
  }
};
const showUSStateField = () => {
  const inputUSStateLi = document.querySelector('.inputUSState_li');
  if (inputUSStateLi) {
    inputUSStateLi.style.display = 'list-item';
  }
};
const showStateRequiredMessage = () => {
  var _a;
  const errorDiv = (_a = document.querySelector('.inputUSState_li')) === null || _a === void 0 ? void 0 : _a.querySelector('.error');
  if (errorDiv) {
    errorDiv.textContent = 'This information is required.';
  }
};
const clearStateRequiredMessage = () => {
  var _a;
  const errorDiv = (_a = document.querySelector('.inputUSState_li')) === null || _a === void 0 ? void 0 : _a.querySelector('.error');
  if (errorDiv) {
    errorDiv.textContent = '';
  }
};
const countryChangeListener = ev => {
  const combinedLocation = ev.target;
  const inputUSState = document.getElementById('inputUSState');
  if (combinedLocation && inputUSState) {
    inputUSState.value = 'XXX';
    if (combinedLocation.value === '|NUSSAXXX|US|XXX|') {
      showUSStateField();
      disablePlaceholderState();
    } else {
      hideUSStateField();
    }
  }
  toggleControls();
};
const attachCountryChangeListener = () => {
  const combinedLocation = document.getElementById('combinedLocation');
  combinedLocation === null || combinedLocation === void 0 ? void 0 : combinedLocation.addEventListener('change', countryChangeListener);
};
const removeCountryChangeListener = () => {
  const combinedLocation = document.getElementById('combinedLocation');
  combinedLocation === null || combinedLocation === void 0 ? void 0 : combinedLocation.removeEventListener('change', countryChangeListener);
};
const attachUSStateChangeListener = () => {
  const inputUSState = document.getElementById('inputUSState');
  inputUSState === null || inputUSState === void 0 ? void 0 : inputUSState.addEventListener('change', toggleControls);
};
const removeUSStateChangeListener = () => {
  const inputUSState = document.getElementById('inputUSState');
  inputUSState === null || inputUSState === void 0 ? void 0 : inputUSState.removeEventListener('change', toggleControls);
};
const toggleControls = () => {
  const combinedLocation = document.getElementById('combinedLocation');
  const inputUSState = document.getElementById('inputUSState');
  if ((combinedLocation === null || combinedLocation === void 0 ? void 0 : combinedLocation.value) === '|NUSSAXXX|US|XXX|') {
    if ((inputUSState === null || inputUSState === void 0 ? void 0 : inputUSState.value) != 'XXX') {
      enableSubmitButton();
      clearStateRequiredMessage();
    } else {
      showStateRequiredMessage();
      disableSubmitButton();
    }
  } else {
    enableSubmitButton();
  }
};
const disablePlaceholderState = () => {
  const inputUSState = document.getElementById('inputUSState');
  if (inputUSState) {
    const placeholderOption = inputUSState.querySelector('option[value="XXX"]');
    const emptyOptionValue = inputUSState.querySelector('option[value=""]');
    if (placeholderOption) {
      placeholderOption.disabled = true;
      placeholderOption.style.display = 'none';
    }
    if (emptyOptionValue) {
      inputUSState.removeChild(emptyOptionValue);
    }
  }
};
const initUsStateLogic = () => {
  hideUSStateField();
  removeCountryChangeListener();
  attachCountryChangeListener();
  removeUSStateChangeListener();
  attachUSStateChangeListener();
  toggleControls();
};
exports.initUsStateLogic = initUsStateLogic;
//# sourceMappingURL=usStates.js.map